// Actions
export const setDailyTasks = ({ commit }, payload) => {
  commit('SET_DAILY_TASKS', payload)
}
export const addDailyTasks = ({ commit }, payload) => {
  commit('ADD_DAILY_TASKS', payload)
}
export const setDailyTasksLoading = ({ commit }, payload) => {
  commit('SET_DAILY_TASKS_LOADING', payload)
}

export const setProfessional = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL', payload)
}
export const addProfessional = ({ commit }, payload) => {
  commit('ADD_PROFESSIONAL', payload)
}
export const setProfessionalLoading = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL_LOADING', payload)
}

export const setClients = ({ commit }, payload) => {
  commit('SET_CLIENTS', payload)
}
export const addClients = ({ commit }, payload) => {
  commit('ADD_CLIENTS', payload)
}
export const setClientsLoading = ({ commit }, payload) => {
  commit('SET_CLIENTS_LOADING', payload)
}
export const selectAllClients = ({ commit }, payload) => {
  commit('SELECT_ALL_CLIENTS', payload)
}
export const doneClients = ({ commit }, payload) => {
  commit('DONE_CLIENTS', payload)
}

export const setShowModalAssign = ({ commit }, payload) => {
  commit('CHANGE_SHOW_MODAL_ASSIGN', payload)
}

export const setIdModalAssign = ({ commit }, payload) => {
  commit('SET_ID_MODAL_ASSIGN', payload)
}

export const setInfoAlert = ({ commit }, payload) => {
  commit('SET_INFO_ALERT', payload)
}

export const clearInfoAlert = ({ commit }, payload) => {
  commit('CLEAR_INFO_ALERT', payload)
}

export const setImport = ({ commit }, payload) => {
  commit('SET_IMPORT', payload)
}
export const addImport = ({ commit }, payload) => {
  commit('ADD_IMPORT', payload)
}
export const setImportLoading = ({ commit }, payload) => {
  commit('SET_IMPORT_LOADING', payload)
}

export const setExport = ({ commit }, payload) => {
  commit('SET_EXPORT', payload)
}
export const addExport = ({ commit }, payload) => {
  commit('ADD_EXPORT', payload)
}
export const setExportLoading = ({ commit }, payload) => {
  commit('SET_EXPORT_LOADING', payload)
}
